/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});



/*	var feed = new Instafeed({
        get: 'tagged',
        tagName: 'awesome',
        clientId: 'YOUR_CLIENT_ID'
    });
    feed.run();
*/
 /*   window.sr = ScrollReveal();
	sr.reveal('.cr-block-ani', { 
	duration: 600,
	delay: 300,
	easing: 'ease-out',
	origin: 'bottom',
	reset: true,
	scale: 1,
	viewFactor: 0.3,
	afterReveal: function (el) { el.classList.add('is-visible') },
	afterReset: function (el) { el.classList.remove('is-visible') },
	});
	*/

	AOS.init({
		easing: 'ease-out-sine',
		duration: 1000
    });

    myParaxify = paraxify('.paraxify');

	jQuery(window).load(function() {
			jQuery( ".eye-line" ).animate({
			height: "100%", 
		}, 1500 );
	});

	function blinker() {
    	jQuery('.eye-line').fadeOut(500);
    	jQuery('.eye-line').fadeIn(500);
	}

	setInterval(blinker, 7000);

	jQuery('.go_to').click(function(e){
		var jump = jQuery(this).attr('href');
		var new_position = jQuery(jump).offset();
		jQuery('html, body').stop().animate({ scrollTop: new_position.top }, 1000);
		e.preventDefault();
	});
}); 